// src/context/LikesContext.js
import React, { createContext, useState, useContext, useCallback, useEffect } from 'react';
import API from '../api/client';
import { AuthContext } from './AuthContext';
import { LocationContext } from './LocationContext';

export const LikesContext = createContext();

export const LikesProvider = ({ children }) => {
  const [likes, setLikes] = useState({});
  const [favorites, setFavorites] = useState([]);

  const { isAuthenticated } = useContext(AuthContext);
  const { coords } = useContext(LocationContext);

  // Limpiar likes y favoritos al cerrar sesión
  useEffect(() => {
    if (!isAuthenticated) {
      setLikes({});
      setFavorites([]);
    }
  }, [isAuthenticated]);

  // Llamada a la API para obtener favoritos
  const loadFavorites = useCallback(async ({ lat, lng } = {}) => {
    try {
      const params = {};
      if (lat != null && lng != null) {
        params.lat = lat;
        params.lng = lng;
      }
      const response = await API.get('/favorites/', {
        params,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });
      setFavorites(response.data);
      console.log('[LikesContext] Favorites cargados:', response.data);
    } catch (error) {
      console.error('[LikesContext] Error cargando favorites:', error);
    }
  }, []);

  // Carga inicial y refresco por cambio de ubicación
  useEffect(() => {
    if (
      isAuthenticated &&
      coords?.lat != null &&
      coords?.lng != null
    ) {
      loadFavorites({ lat: coords.lat, lng: coords.lng });
    }
  }, [isAuthenticated, coords.lat, coords.lng, loadFavorites]);

  return (
    <LikesContext.Provider value={{ likes, updateLike: (petId, newState) => setLikes(prev => ({ ...prev, [petId]: newState })), favorites, loadFavorites }}>
      {children}
    </LikesContext.Provider>
  );
};
